import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import FlowEngine from '../../amsRequest/flowengine';
import ams from '../../common/ams';
var defaultOption = {
  iActivityId: '',
  iFlowId: '',
  sData: {},
  fFlowSubmitEnd: null,
  fFlowSubmitFailed: null
};
export default (function (opt) {
  return new Promise(function (resolve, reject) {
    var iActivityId = opt.iActivityId,
        iFlowId = opt.iFlowId,
        flowConfig = opt.flowConfig;
    ams.amsInit(iActivityId, iFlowId, flowConfig).then(function (_ref) {
      var config = _ref.config;

      var option = _objectSpread(_objectSpread({}, defaultOption), config);

      return option;
    }).then(function (option) {
      var iAMSActivityId = option.iAMSActivityId,
          iFlowId = option.iFlowId,
          sData = option.sData,
          sNeedSubmitPopDiv = option.sNeedSubmitPopDiv,
          fFlowSubmitEnd = option.fFlowSubmitEnd,
          fFlowSubmitFailed = option.fFlowSubmitFailed;
      console.log(sData);
      var FlowSubmitJson = {
        iActivityId: iAMSActivityId,
        iFlowId: iFlowId,
        sData: sData,
        sNeedSubmitPopDiv: sNeedSubmitPopDiv,
        fFlowSubmitEnd: fFlowSubmitEnd,
        fFlowSubmitFailed: fFlowSubmitFailed
      };
      FlowEngine.submit(FlowSubmitJson).then(function (res) {
        resolve(res);
      })["catch"](function (err) {
        reject(err);
      });
    })["catch"](function (err) {
      reject(err);
    });
  });
});